import React, { useCallback } from 'react'

import Input from '../Input/Input'
import type { IKitControlProps } from '../KitTypes'

type InputDefaultType = Omit<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'onChange' | 'type' | 'prefix' | 'size' | 'onFocus' | 'onBlur' | 'defaultValue' | 'name' | 'value'
>

export interface IInputNumberProps extends InputDefaultType, IKitControlProps<number | null> {
  // TODO: add XS
  placeholder?: string
  prefix?: React.ReactNode
  postfix?: React.ReactNode
  textAlign?: 'left' | 'right' | 'center'
  minWidth?: number
  error?: boolean
  width?: React.CSSProperties['width']
  shrink?: React.CSSProperties['flexShrink']
  fluid?: boolean
}

const InputNumber = React.forwardRef<HTMLInputElement, IInputNumberProps>(
  ({ defaultValue, value = defaultValue, onChange, ...rest }, inputRef) => {
    const parser = useCallback((input: string) => {
      const value = input
        .replace(/[^0-9.,-]/g, '')
        .replace(/,/g, '.')
        .replace(/-/g, (match, offset) => (offset > 0 ? '' : match))
      const parts = value.split('.')
      return parts.length > 1 ? `${parts[0]}.${parts.slice(1).join('')}` : parts[0]
    }, [])

    const handleChange = useCallback(
      (value: string) => {
        const parsed = parseFloat(value.replace(/[^0-9.,-]/g, ''))
        if (isNaN(parsed)) {
          onChange?.(null)
        } else {
          onChange?.(parsed)
        }
      },
      [onChange],
    )

    return (
      <Input
        {...rest}
        autoComplete='off'
        el='inputNumber'
        inputMode='decimal'
        onChange={handleChange}
        parser={parser}
        ref={inputRef}
        value={(typeof value === 'number' ? String(value) : value) ?? ''}
      />
    )
  },
)

InputNumber.displayName = 'InputNumber'

export default InputNumber
